import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import Logo from "../../components/header/Logo";
import NavMenu from "../../components/header/NavMenu";
import IconGroup from "../../components/header/IconGroup";
import MobileMenu from "../../components/header/MobileMenu";
import HeaderTop from "../../components/header/HeaderTop";
import Marquee from "react-fast-marquee";
const HeaderOne = ({
  layout,
  top,
  borderStyle,
  headerPaddingClass,
  headerPositionClass,
  headerBgClass
}) => {
  const [scroll, setScroll] = useState(0);
  const [headerTop, setHeaderTop] = useState(0);

  useEffect(() => {
    const header = document.querySelector(".sticky-bar");
    //console.log(header.offsetTop);
    setHeaderTop(header.offsetTop);
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleScroll = () => {
    const header = document.querySelector(".sticky-bar");
    setScroll(window.scrollY);
  };

  return (
    <header
      className={`header-area clearfix ${headerBgClass ? headerBgClass : ""} ${
        headerPositionClass ? headerPositionClass : ""
      }`}
    >

     <div className={`sticky-bar header-res-padding clearfix ${
      scroll > headerTop ? "stick" : ""}`} >

       <div className="logo-bar" >
        <div className={layout === "container-fluid" ? layout : "container"}>
          <div className="row">
            <div className="col-xl-6 col-lg-6 col-md-10 col-10">
              {/* header logo */}
              <Logo imageUrl="/assets/img/logo/cologo.png" logoClass="logo" />
            {/*  {
                layout === "container-fluid" ? 
                `<Logo imageUrl="/assets/img/logo/logo.png" logoClass="logo" />`
                :
                `<Logo imageUrl="/assets/img/logo/logoa.png" logoClass="logo" />`              
              } */}
            </div>
            <div className="col-xl-5 col-lg-5 col-md-3 col-3 d-none d-lg-block">
              {/* Nav menu */}
              <NavMenu /> 
            </div>           
            <div className="col-xl-1 col-lg-1 col-md-2 col-2">            
             <HeaderTop borderStyle={borderStyle} />
            </div>
          </div>
        </div> 
        </div>
       <div className="status-bar"> 
       <div className={layout === "container-fluid" ? layout : "container"}>
     {/*   <div
        className={`${headerPaddingClass ? headerPaddingClass : ""} ${  
          top === "visible" ? "d-none d-lg-block" : "d-none"
        } header-top-area ${
          borderStyle === "fluid-border" ? "border-none" : ""
        }        
        `}
        >
      </div>  */}
        
        <div >
        {/* Icon group */}
        <IconGroup  borderStyle={borderStyle} />
        </div> 

        {/* mobile menu */}
        <MobileMenu />
      </div>
      </div>
     </div>     
    <div className="shopbody" >        
    </div>  
    </header>
  );
};

HeaderOne.propTypes = {
  borderStyle: PropTypes.string,
  headerPaddingClass: PropTypes.string,
  headerPositionClass: PropTypes.string,
  layout: PropTypes.string,
  top: PropTypes.string
};

export default HeaderOne;
